import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Hero,
  UnlockOpportunities,
  ScrollToTopOnMount,
  Numeral,
} from '../coreui';

import SimpleSteps from './simpleSteps';
import BeyondTraditionalInvesting from './BeyondTraditionalInvesting';
import HowWeSelect from './HowWeSelect';
import Highlighted3ColCallout from '../components/Highlighted3ColCallout';
import BrowseLink from '../components/BrowseLink';
import QueueFAQItems from '../components/queueFAQItems';
import Section from '../ioDetails/components/section';
import heroBannerImage from '../assets/HIW_hero.jpg';

class HowItWorks extends React.Component {
  // TODO -- Make this constructor not pointless or revert to stateless function
  constructor(props) {
    super(props);
    this.state = {
      justHereToGetOutOfLinting: null,
    };
  }


  render() {
    const {
      user,
      amountPaidOut,
      totalPropertyValueFinanced,
      totalMembers,
    } = this.props;

    const isLoggedIn = user.isLoggedIn;
    const calloutTitle = 'Established Track Record';
    const calloutSubTitle = `We are proud to offer institutional quality deals to investors seeking to build
    wealth through commercial real estate. Our straightforward approach focuses on: offering smart diversification strategies,
    generating cash flow, and creating value in office, retail, and apartment buildings.`;
    const calloutHighlights = [
      {
        highlight: (amountPaidOut) ? <Numeral value={amountPaidOut} format="$0a+" /> : null,
        description: 'Paid Out To Our Investors',
      },
      {
        highlight: (totalPropertyValueFinanced) ?
          <Numeral value={totalPropertyValueFinanced} format="$0a+" /> :
          null,
        description: 'Property Value Financed',
      },
      {
        highlight: (totalMembers) ? <Numeral value={totalMembers} format="0a+" /> : null,
        description: 'Registered Membership Base',
      },
    ];
    return (
      <React.Fragment>
        <ScrollToTopOnMount />
        <Hero
          image={heroBannerImage}
          header="Commercial Real Estate, Simplified"
          bgPosition="left"
        />
        <SimpleSteps
          isLoggedIn={isLoggedIn}
        />
        <BeyondTraditionalInvesting
          isLoggedIn={isLoggedIn}
        />
        <HowWeSelect />
        <Section
          bg="gray.0"
        >
          <Highlighted3ColCallout
            title={calloutTitle}
            subTitle={calloutSubTitle}
            highlights={calloutHighlights}
            cta={<BrowseLink isLoggedIn={isLoggedIn} />}
          />
        </Section>
        <QueueFAQItems
          title="Popular Questions"
          queueName="popular_questions"
        />
        <UnlockOpportunities
          isLoggedIn={isLoggedIn}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.howItWorks.user,
  totalMembers: state.howItWorks.totalMembers,
  totalPropertyValueFinanced: state.howItWorks.totalPropertyValueFinanced,
  amountPaidOut: state.howItWorks.amountPaidOut,
});

HowItWorks.propTypes = {
  user: PropTypes.object,
  totalMembers: PropTypes.number,
  totalPropertyValueFinanced: PropTypes.number,
  amountPaidOut: PropTypes.number,
};

export default connect(mapStateToProps)(HowItWorks);
